"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGroupItemComponent = DefaultGroupItemComponent;
const react_1 = __importDefault(require("react"));
function DefaultGroupItemComponent({ selector, PropertyLabelComponent, PropertySelectorComponent }) {
    return (react_1.default.createElement("tr", { key: selector.propertyName },
        react_1.default.createElement("td", null,
            react_1.default.createElement(PropertyLabelComponent, Object.assign({}, selector.labelComponentProps))),
        react_1.default.createElement("td", null,
            react_1.default.createElement(PropertySelectorComponent, Object.assign({}, selector.selectorComponentProps)))));
}
//# sourceMappingURL=default-group-item-component.js.map